import * as angular from 'angular';

import { Helper } from '../../common/helpers/helper';
import { ComponentDefinition } from '../../models';

const none = 'None';

class SymbolSelectController implements angular.IComponentController {
    disableWithNone: string;
    model: string;
    parentModel: {};
    symbols: string[];

    static $inject = [];

    $onInit() {
        const symbols = this.disableWithNone ? [none] : [];
        symbols.push(...Helper.getSymbols());
        this.symbols = symbols;

        if (this.disableWithNone && this.parentModel) {
            const hasSymbol = this.parentModel[this.disableWithNone];
            if (!hasSymbol) {
                this.model = none;
            }
        }
    }

    onChange() {
        if (this.disableWithNone && this.parentModel) {
            const hasSymbol = this.model && this.model !== none;
            this.parentModel[this.disableWithNone] = hasSymbol;
        }
    }
}

export const wtSymbolSelect: ComponentDefinition = {
    componentId: 'wtSymbolSelect',
    controller: SymbolSelectController,
    template: require('./symbolSelect.component.html'),
    controllerAs: 'vm',
    bindings: {
        disableWithNone: '<?',
        isDisabled: '<?',
        model: '=',
        parentModel: '<?',
        showName: '<?'
    }
};